/**
* DO NOT EDIT THIS FILE.
* See the following change record for more information,
* https://www.drupal.org/node/2815083
* @preserve
**/
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import OverlayService from "./overlay-service.es6.js";
var Navigation = function () {
  function Navigation() {
    _classCallCheck(this, Navigation);
    this.desktopNavWrapperId = 'desktop-primary-nav';
    this.desktopNavWrapper = document.querySelector("#".concat(this.desktopNavWrapperId, ":not(.").concat(this.desktopNavWrapperId, "-processed)"));
    this.mobileNavWrapperId = document.querySelector('#mobile-primary-nav');
    this.mobileNavWrapper = this.mobileNavWrapperId.querySelector('.mobile-nav');
    if (this.desktopNavWrapper && this.mobileNavWrapper) {
      this.desktopNavWrapper.classList.add("".concat(this.desktopNavWrapperId, "-processed"));
      this.navButton = document.querySelector('.mobile-nav-button');
      this.body = document.querySelector('body');
      this.desktopNavButtons = this.desktopNavWrapper.querySelectorAll('.primary-nav__menu-item--level-1');
      this.clickableNavButtons = this.desktopNavWrapper.querySelectorAll('.item-title-wrapper');
      this.desktopExpandedMenuWrapper = this.desktopNavWrapper.querySelectorAll('.expanded-menu-wrapper');
      this.mobileNavCloseButton = this.mobileNavWrapper.querySelector('.close-button');
      this.mobileNavButtons = this.mobileNavWrapper.querySelectorAll('.mobile-nav-button');
      this.mobileMenuSearchBar = this.mobileNavWrapperId.querySelector('.mobile-menu-search-bar');
      this.smallBrandingLogo = this.desktopNavWrapper.querySelector('.site-branding');
      this.smallLogoHasSlidIn = false;
      this.header = document.querySelector('.site-header__inner__container');
      this.numberOfPixelsToHideInHeader = 75;
      this.amountToScrollToShowSmallerLogo = 0;
      this.siteAlertWrapper = document.querySelector('.region--site-alert');
      this.secondaryMenuWrapper = document.querySelector('.secondary-nav-and-search-button-wrapper');
      this.accountWrapperId = document.querySelector('#account-nav');
      this.accountButton = document.querySelector('.account-button-wrapper');
    }
  }
  return _createClass(Navigation, [{
    key: "toggleMobileNav",
    value: function toggleMobileNav() {
      this.mobileNavWrapperId.classList.toggle('active');
      if (this.mobileNavWrapperId.classList.contains('active')) {
        this.overlayService.toggleOverlay(true);
      } else {
        this.overlayService.toggleOverlay(false);
      }
    }
  }, {
    key: "closeActivePrimaryMenu",
    value: function closeActivePrimaryMenu() {
      var activeDesktop = this.desktopNavWrapper.querySelectorAll('.active');
      activeDesktop.forEach(function (activeEl) {
        activeEl.classList.remove('active');
      });
      this.mobileNavWrapperId.classList.remove('active');
      var activeMobile = this.mobileNavWrapperId.querySelectorAll('.active');
      activeMobile.forEach(function (activeEl) {
        activeEl.classList.remove('active');
      });
    }
  }, {
    key: "closeAllActiveMenus",
    value: function closeAllActiveMenus() {
      this.closeActivePrimaryMenu();
      this.accountButton.classList.remove('active');
      var activeAccountMenus = this.accountWrapperId.querySelectorAll('.active');
      activeAccountMenus.forEach(function (activeEl) {
        activeEl.classList.remove('active');
      });
    }
  }, {
    key: "onDesktopTopMenuClicked",
    value: function onDesktopTopMenuClicked(element) {
      if (element.parentElement.classList.contains('active')) {
        this.closeAllActiveMenus();
        this.overlayService.toggleOverlay(false);
        element.parentElement.classList.remove('active');
      } else {
        this.closeAllActiveMenus();
        element.parentElement.classList.add('active');
        this.overlayService.toggleOverlay(true);
      }
    }
  }, {
    key: "setDesktopNavButtonsClickEvents",
    value: function setDesktopNavButtonsClickEvents() {
      var _this = this;
      this.clickableNavButtons.forEach(function (element) {
        element.addEventListener('click', function () {
          _this.onDesktopTopMenuClicked(element);
        });
      });
    }
  }, {
    key: "setSecondLevelMenuWidth",
    value: function setSecondLevelMenuWidth(secondLevelMobileMenuWrapper) {
      var topMenuWidth = this.mobileNavWrapper.clientWidth;
      secondLevelMobileMenuWrapper.style.width = "".concat(topMenuWidth, "px");
    }
  }, {
    key: "setSecondLevelBackButtonClickEvents",
    value: function setSecondLevelBackButtonClickEvents(secondLevelMobileMenuWrapper) {
      var _this2 = this;
      var secondLevelBackButton = secondLevelMobileMenuWrapper.querySelector('.back-button');
      secondLevelBackButton.addEventListener('click', function () {
        _this2.activeButton.classList.remove('active');
      });
    }
  }, {
    key: "onMobileTopMenuClicked",
    value: function onMobileTopMenuClicked(button) {
      button.parentElement.classList.add('active');
      this.activeButton = button.parentElement;
      var secondLevelMobileMenuWrapper = this.activeButton.querySelector('.second-level-wrapper');
      if (secondLevelMobileMenuWrapper) {
        this.setSecondLevelMenuWidth(secondLevelMobileMenuWrapper);
        this.setSecondLevelBackButtonClickEvents(secondLevelMobileMenuWrapper);
      }
    }
  }, {
    key: "addTopLevelMobileNavClickEvents",
    value: function addTopLevelMobileNavClickEvents() {
      var _this3 = this;
      this.mobileNavButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          _this3.onMobileTopMenuClicked(button);
        });
      });
      this.mobileMenuSearchBar.addEventListener('click', function () {
        _this3.closeAllActiveMenus();
      });
    }
  }, {
    key: "addMobileNavToggleClickEvents",
    value: function addMobileNavToggleClickEvents() {
      var _this4 = this;
      this.navButton.addEventListener('click', function () {
        _this4.closeAllActiveMenus();
        _this4.toggleMobileNav();
      });
      this.mobileNavCloseButton.addEventListener('click', function () {
        _this4.closeAllActiveMenus();
        _this4.overlayService.toggleOverlay(false);
      });
    }
  }, {
    key: "addMobileNavClickEvents",
    value: function addMobileNavClickEvents() {
      this.addMobileNavToggleClickEvents();
      this.addTopLevelMobileNavClickEvents();
    }
  }, {
    key: "slideSmallBrandingLogo",
    value: function slideSmallBrandingLogo() {
      if (window.scrollY > this.amountToScrollToShowSmallerLogo) {
        this.smallBrandingLogo.classList.add('slide-in');
        this.smallBrandingLogo.classList.remove('slide-out');
        this.secondaryMenuWrapper.classList.add('hidden');
        this.smallLogoHasSlidIn = true;
      } else if (window.scrollY < this.amountToScrollToShowSmallerLogo && this.smallLogoHasSlidIn) {
        this.smallBrandingLogo.classList.remove('slide-in');
        this.smallBrandingLogo.classList.add('slide-out');
        this.secondaryMenuWrapper.classList.remove('hidden');
      }
    }
  }, {
    key: "init",
    value: function init() {
      var _this5 = this;
      this.navButton.setAttribute('aria-controls', this.desktopNavWrapperId);
      this.navButton.setAttribute('aria-expanded', 'false');
      window.addEventListener('load', function () {
        _this5.setDesktopNavButtonsClickEvents();
        _this5.addMobileNavClickEvents();
        window.addEventListener('scroll', function () {
          if (_this5.siteAlertWrapper) {
            _this5.amountToScrollToShowSmallerLogo = _this5.siteAlertWrapper.scrollHeight + _this5.numberOfPixelsToHideInHeader;
          } else {
            _this5.amountToScrollToShowSmallerLogo = _this5.numberOfPixelsToHideInHeader;
          }
          _this5.slideSmallBrandingLogo();
        });
        _this5.overlayService = new OverlayService();
        _this5.overlayService.mobileOverlay.addEventListener('click', function () {
          _this5.closeAllActiveMenus();
          _this5.overlayService.toggleOverlay(false);
        });
        _this5.overlayService.desktopOverlay.addEventListener('click', function () {
          _this5.closeAllActiveMenus();
          _this5.overlayService.toggleOverlay(false);
        });
        _this5.overlayService.headerOverlay.addEventListener('click', function () {
          _this5.closeAllActiveMenus();
          _this5.overlayService.toggleOverlay(false);
        });
      });
    }
  }]);
}();
export { Navigation as default };
(function () {
  var navigation = new Navigation();
  navigation.init();
})(Drupal);